import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material'
import {
  BookingType,
  BookingTypeIcons,
  SupplierRegionType,
} from 'api/models/Common/JyrneyEnums'
import RadioSwitch from 'components/FormFields/RadioSwitch/RadioSwitch'

import { Controller, useFormContext } from 'react-hook-form'

export function SupplierSettings() {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '80%',
        justifyItems: 'flex-start',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '25px',
          marginTop: '15px',
          justifyContent: 'flex-start',
        }}
      >
        <Controller
          name="settings.isOnDemandPricing"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'On demand pricing?'}
              />
            )
          }}
        />
        <Controller
          name="settings.isSelfInvoicing"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Self invoicing?'}
              />
            )
          }}
        />
        <Controller
          name="settings.isDelayedInvoicing"
          control={control}
          render={({ field }) => {
            return (
              <RadioSwitch
                {...field}
                options={[
                  { value: true, label: 'On' },
                  { value: false, label: 'Off' },
                ]}
                displayMode="compact"
                onChange={(e: any) => field.onChange(e.target.value === 'true')}
                label={'Delayed invoicing?'}
              />
            )
          }}
        />
      </Box>
      <Box>
        <Controller
          name="services"
          control={control}
          render={({ field }) => {
            return (
              <FormControl sx={{ minWidth: '350px' }}>
                <InputLabel id="supplier-services">
                  Available Services
                </InputLabel>
                <Select
                  {...field}
                  labelId="supplier-services"
                  id="supplier-services-select"
                  multiple
                  input={
                    <OutlinedInput id="select-multiple-chip" label="Services" />
                  }
                  onChange={(e) => field.onChange(e.target.value)}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selected.map((value: any) => {
                        const IconComponent = (BookingTypeIcons as any)[value]
                        return (
                          <Chip
                            color="primary"
                            icon={IconComponent ? <IconComponent /> : undefined}
                            key={value}
                            label={value}
                          />
                        )
                      })}
                    </Box>
                  )}
                  required={!!errors.services && !!(errors.services as any)}
                  error={!!errors.services && !!(errors.services as any)}
                >
                  {Object.entries(BookingType).map((name) => (
                    <MenuItem key={name[0]} value={name[0]}>
                      {name[1]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <Controller
          name="regionName"
          control={control}
          render={({ field }) => {
            return (
              <FormControl sx={{ minWidth: '250px' }}>
                <InputLabel id="supplier-region">Region</InputLabel>
                <Select
                  {...field}
                  labelId="supplier-region"
                  id="supplier-region-select"
                  input={
                    <OutlinedInput
                      id="select-single-chip"
                      label="Service Region"
                    />
                  }
                  required={!!errors.regionName && !!(errors.regionName as any)}
                  error={!!errors.regionName && !!(errors.regionName as any)}
                >
                  {Object.entries(SupplierRegionType).map((name) => (
                    <MenuItem key={name[0]} value={name[0]}>
                      {name[1]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )
          }}
        />

        <Controller
          name="termsAndConditions"
          control={control}
          render={({ field }) => {
            return (
              <FormControl sx={{ minWidth: '450px' }}>
                <TextField {...field} label="Terms and Conditions Link" />
              </FormControl>
            )
          }}
        />
      </Box>
    </Box>
  )
}
